import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Autenticacao } from '../providers/autenticacao';

@Injectable()
export class Validacao {

  static validacaoService: Autenticacao;

  constructor(
    validacaoService: Autenticacao
  ) {
    Validacao.validacaoService = validacaoService;
  }

  checkCpf(input: FormControl) {

    return new Promise((resolve, reject) => {

      if (input.value.length != '14') {
        resolve(null);
      } else {
        Validacao.validacaoService.checkCpf(input.value.substring(0, 14))
          .then(data => {
            if (data['response'] == 'cpf_existe') {
              resolve({ "cpfExistente": true });
            } else {
              resolve(null);
            }
          }, err => {
            resolve(null);
          });
      }
    })
  }

  /*
  * Validação de CPF: Verifica se o CPF possui padrão de numeração válida. Utiliza o algoritmo da Receita Federal.
  */

  cpfValidator(input: FormControl) {

    if (input.value.length == '14') {

      if (input.value.substring(0, 14) == "000.000.000-00") {
        return { "cpfInvalido": true };
      }

      let Soma;
      let Resto;
      Soma = 0;
      let strCPF = input.value.substring(0, 14).replace(/\D/g, '');

      for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return { "cpfInvalido": true };

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return { "cpfInvalido": true };
      return null;
    }
  }

  /*
  * Validação de E-mail
  */

  emailValidator(input: FormControl) {
    if (!input.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return { 'emailInvalido': true };
    } else {
      return null;
    }
  }

  /*
  * Verifica se a senha e a verificação da senha são iguais
  */

  isMatching(group: FormGroup) {
    var firstPassword = group.controls['password'].value;
    var secondPassword = group.controls['confirmPassword'].value;

    if ((firstPassword && secondPassword) && (firstPassword != secondPassword)) {
      group.controls['confirmPassword'].setErrors({ "senhaDiferente": true });
    } else {
      group.controls['confirmPassword'].setErrors(null);
    }
  }

}




// WEBPACK FOOTER //
// ./src/validators/validacao.ts